import type { SpacingValue } from '../../../common/sizing';

export const chassisVars = {
  slot: {
    /**
     * The slot's width across, and the pitch of a row of them.
     *
     * The rail's two 14px indicator icons come to 28, as does the 24px glyph. Everything a slot draws
     * is this wide — recess, rail, caption row — so the number that decides how many icons fit also
     * decides where every glyph on the faceplate lands. Indicator icons stop being legible below
     * 14px. See `SlotIndicators`.
     */
    width: 32,
    height: 40,
    diagram: 20,
    caption: 16,
    captionInset: 2,
    indicator: 16,
    indicatorIcon: 14,
    heightWithIndicators: 56,
    radius: 6,
  },

  unit: {
    /** The name pill's width across, which is `labelInset` either side of one `labelLine`. */
    label: 20,
    labelLine: 16,
    labelInset: 2,
  },

  gap: {
    slot: 8,
    column: 4,
    section: 8,
    unit: 16,
  },

  padding: 8,
  radius: 12,
} satisfies {
  slot: {
    width: SpacingValue;
    height: SpacingValue;
    diagram: SpacingValue;
    caption: SpacingValue;
    indicator: SpacingValue;
    indicatorIcon: SpacingValue;
    captionInset: SpacingValue;
    heightWithIndicators: SpacingValue;
    radius: SpacingValue;
  };
  unit: {
    label: SpacingValue;
    labelLine: SpacingValue;
    labelInset: SpacingValue;
  };
  gap: {
    slot: SpacingValue;
    column: SpacingValue;
    section: SpacingValue;
    unit: SpacingValue;
  };
  padding: SpacingValue;
  radius: SpacingValue;
};
